<template>
  <sui-segment attached="bottom" :loading="loading">
    <sui-table celled striped size="large">
      <sui-table-header class="full-width">
        <sui-table-row text-align="center">
          <sui-table-header-cell>Date</sui-table-header-cell>
          <sui-table-header-cell>Description</sui-table-header-cell>
          <sui-table-header-cell>Amount&nbsp;<span data-tooltip="Including all taxes"><i class="info circle icon" /></span></sui-table-header-cell>
          <sui-table-header-cell>Receipt</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-if="!payments.length">
        <sui-table-row>
          <sui-table-cell colspan="4" textAlign="center">
            No payments.
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-body v-if="payments.length">
        <sui-table-row v-for="payment in payments" :key="payment.id">
          <sui-table-cell class="date" textAlign="right" collapsing>
            {{momentFormat(payment.event_time, 'MMMM DD, YYYY')}}
          </sui-table-cell>
          <sui-table-cell>
            <i class="icon" :class="iconsByMethod[payment.payment_method]" />
            Payment for <b>{{payment.plan_name.replace('D2C Pro', 'D2C Early Bird')}}</b>
            <span v-show="payment.passthrough.options && payment.passthrough.options.length">
              <span v-for="option in payment.passthrough.options" :key="option.id"> +{{option.amt}} {{tariffsById[option.id].name.replace('annual', '')}}</span>
            </span>
          </sui-table-cell>
          <sui-table-cell class="amount" textAlign="right" collapsing>
            {{toFixedAmount(payment.sale_gross)}} {{payment.currency}}
            <span v-show="payment.balance_currency !== payment.currency">({{toFixedAmount(payment.balance_gross)}} {{payment.balance_currency}})</span>
          </sui-table-cell>
          <sui-table-cell textAlign="center" collapsing>
            <a :href="payment.receipt_url" target="_blank" data-goal="SETTINGS_PAYMENTS_OPEN_RECEIPT">Open</a>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-cell colspan="4" textAlign="right">
            Page&nbsp;{{filter.page}}
            <sui-button-group class="page-buttons" size="small">
              <sui-button :disabled="filter.page === 1" @click="filter.page -= 1">Prev</sui-button>
              <sui-button :disabled="filter.limit > payments.length" @click="filter.page += 1">Next</sui-button>
            </sui-button-group>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'
  import api from '@/api'

  export default {
    name: 'SettingsPaymentsView',
    data() {
      return {
        loading: false,
        payments: [],
        filter: {
          sort: '-event_time',
          page: 1,
          limit: 50,
        },
        iconsByMethod: {
          'card': 'credit card',
          'paypal': 'paypal',
          'free': 'handshake',
          'apple-pay': 'apple',
          'wire-transfer': 'money check alternate',
        },
      }
    },
    computed: {
      ...mapGetters(['tariffsById']),
    },
    watch: {
      filter: {
        deep: true,
        immediate: true,
        handler() {
          this.fetchPayments()
        },
      },
    },
    methods: {
      fetchPayments() {
        this.loading = true
        return api.getAccountPayments(this.filter).then(payments => {
          this.payments = payments
        }).finally(() => {
          this.loading = false
        })
      },
      toFixedAmount(string) {
        return parseFloat(string).toFixed(2)
      },
    },
  }
</script>

<style scoped>
  .table { white-space: nowrap; }
  .amount { font-family: monospace; }
  .page-buttons { margin: 0 0 0 1em!important; }
</style>
